import { detectBrowser } from './detectBrowser';
import { invariant } from './invariant';

export function getCoepHeader(userAgent: string) {
  const { browserName, fullVersion } = detectBrowser(userAgent);

  if (['Chrome', 'Edge', 'Opera'].includes(browserName)) {
    return 'credentialless';
  } else if (browserName === 'Firefox') {
    invariant(fullVersion);

    if (getMajorVersion(fullVersion) > 118) {
      return 'credentialless';
    }
  }

  return 'require-corp';
}

function getMajorVersion(version: string) {
  return parseInt(version.split('.')[0], 10);
}
